import { Box, TextField, IconButton, Button } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { Add } from '@mui/icons-material';

export const ReportLinksEditor = ({ links, onChange, maxLinks = 4 }: { links: string[]; onChange: (links: string[]) => void; maxLinks?: number }) => {
  const addLink = () => {
    if (links.length < maxLinks) {
      onChange([...links, '']);
    }
  };

  const removeLink = (index: number) => {
    onChange(links.filter((_, i) => i !== index));
  };

  const updateLink = (index: number, value: string) => {
    const newLinks = [...links];
    newLinks[index] = value;
    onChange(newLinks);
  };

  return (
    <Box>
      <Box display="flex" flexDirection="row" flexWrap="wrap" gap={1}>
        {links.map((link, index) => (
          <Box key={index} display="flex" gap={1} mb={1}>
            <TextField
              value={link}
              onChange={e => updateLink(index, e.target.value)}
              placeholder="Enter research report URL"
              fullWidth
              size="small"
              label="Report Link"
            />
            <IconButton onClick={() => removeLink(index)}>
              <Delete />
            </IconButton>
          </Box>
        ))}
      </Box>

      {links.length < maxLinks && (
        <Button onClick={addLink} startIcon={<Add />} variant="outlined" size="small">
          Add Report Link
        </Button>
      )}
    </Box>
  );
};
